import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://velaivendum.com/p-services/",
  timeout: 15000,
});

const useAxios = () => {
  return axiosInstance;
};

export default useAxios;

